import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import AppContext from 'AppContext';
import WithBGImage from 'molecules/WithBGImage';


/**
 * Hero.
 */
const propTypes = {
  background: PropTypes.object, // see Image props. contains key of either data or src.
  overlay: PropTypes.bool,
}
const Hero = React.memo( p => {

  //const AppState = React.useContext( AppContext );

  /* ------ = Lifecyle. = --------------------------------------------------------------------- */

  // Check shade on mount.
  // React.useEffect( () => {
  //
  //   if( ( p.data.shade === AppState.bgShade ) && p.data.shade === 'dark' ) {
  //
  //     AppState.setState( {
  //       bgShade: 'light',
  //     } );
  //     setTimeout( () => {
  //       AppState.setState( {
  //         bgShade: 'dark',
  //       } );
  //     }, 300 );
  //
  //   }
  //   else if( p.data.shade && p.data.shade !== AppState.bgShade ) {
  //
  //     if( p.data.shade === 'light' ) {
  //       AppState.setState( {
  //         bgShade: p.data.shade,
  //       } );
  //     }
  //     else {
  //
  //       setTimeout( () => {
  //         AppState.setState( {
  //           bgShade: p.data.shade,
  //         } );
  //       }, 300 );
  //     }
  //
  //   }
  //
  // }, [] );


  /* ------ = Output. = --------------------------------------------------------------------- */
  const className = classnames(
    'Hero',
    p.className,
    {
      [`is-${p.shade}`]: !! p.shade,
    }
  );

  return(

    <WithBGImage
    Tag="section"
    className={ className }
    image={ p.background }
    overlay={ p.overlay }
    >
      { p.children }
    </WithBGImage>

  )

} );
Hero.propTypes = propTypes;

export default Hero;
